import { render, staticRenderFns } from "./reviewPass.vue?vue&type=template&id=71d163c0"
import script from "./reviewPass.vue?vue&type=script&lang=js"
export * from "./reviewPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports